export const dummySuggestedQuestions = [
  "Filter out all findings that do not have a known exploit, so I can focus on the high-risk set.",
  "Show me the trend of subgroups with highest risk.",
  "Show me the due date stats for subgroups.",
];

export const dummySuggestedQuestionsForAnyaSidebar = [
  "What are the most critical vulnerabilities that need attention right now?",
  "Am I vulnerable to Axios supply chain attack?",
  "Am I vulnerable to Shai Hulud 2.0 attack?",
];

export const ANYA_PROMPTS = {
  FINDING_REMEDIATION: "Give me remediation steps for finding id: ",
  FINDING_SUMMARY: "Summarize the finding id: ",
};

export const ANYA_POLLING_CONFIG = {
  INITIAL_POLL_DELAY: 4000,
  SUBSEQUENT_POLL_INTERVAL: 1000,
  MAX_POLL_TIME: 150000,
} as const;
